// pipe (info tips): the module-level "help tips on/off" preference behind the InfoTipsToggle.
//
// Module-level on purpose (the blessed erp-site-scope pattern): pure *-view.tsx seams and the
// workbench chrome both read it without DI. Unlike the site scope this is a DISPLAY-ONLY
// preference — it never feeds request headers or SWR cache keys, so flipping it re-renders
// consumers reactively (LiveData) but never remounts or refetches a screen.
//
// Persisted per-device (localStorage, default ON) and cross-tab synced via the `storage` event
// (which fires only in OTHER tabs — no echo loop). Reads/writes are try/catch-guarded so a
// blocked storage (private mode) degrades to a session-only choice.
import { LiveData } from '@toeverything/infra';

const KEY = 'pipe.erp.info-tips';

function readInfoTips(): boolean {
  try {
    // Default ON — only the explicit opt-out ('0') turns the tips off.
    return localStorage.getItem(KEY) !== '0';
  } catch {
    return true;
  }
}

export const erpInfoTips$ = new LiveData<boolean>(readInfoTips());

export function setInfoTips(on: boolean) {
  try {
    localStorage.setItem(KEY, on ? '1' : '0');
  } catch {
    // storage unavailable — the choice still applies for this session
  }
  if (erpInfoTips$.value !== on) {
    erpInfoTips$.next(on);
  }
}

if (typeof window !== 'undefined') {
  window.addEventListener('storage', e => {
    if (e.key === KEY) {
      const on = e.newValue !== '0';
      if (erpInfoTips$.value !== on) {
        erpInfoTips$.next(on);
      }
    }
  });
}
